import { Module } from 'vuex';
import { AppState } from '..';
import { prefixValues } from '@/helpers';
import { GetOrderingStatusFeatureFlagsResponse } from '@/models/feature-flags';

export interface FeatureFlagsModuleState {
  orderingStatus: null | GetOrderingStatusFeatureFlagsResponse;
  hasFetchedFlags: boolean;
}

const MUTATION_NAMES = {
  SET_ORDERING_STATUS_FLAGS: 'setOrderingStatusFlags',
  SET_HAS_FETCHED_FLAGS: 'setHasFetchedFlags',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'featureFlags/');

export function makeFeatureFlagsModule(): Module<FeatureFlagsModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      hasFetchedFlags: false,
      orderingStatus: null,
    },
    mutations: {
      [MUTATION_NAMES.SET_ORDERING_STATUS_FLAGS](state, flags) {
        state.orderingStatus = flags;
      },
      [MUTATION_NAMES.SET_HAS_FETCHED_FLAGS](state, value) {
        state.hasFetchedFlags = value;
      },
    },
  };
}
